import { render, staticRenderFns } from "./UserReportTemplate.vue?vue&type=template&id=2f19eb16&scoped=true&"
import script from "./UserReportTemplate.vue?vue&type=script&lang=js&"
export * from "./UserReportTemplate.vue?vue&type=script&lang=js&"
import style0 from "./UserReportTemplate.vue?vue&type=style&index=0&id=2f19eb16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f19eb16",
  null
  
)

export default component.exports